export const SET_ALL_TASKS = 'SET_ALL_TASKS';
export const SET_TASK = 'SET_TASK';
export const SET_DRUG_APPROVAL_TASK = 'SET_DRUG_APPROVAL_TASK';
export const SET_TASK_BY_USER = 'SET_TASK_BY_USER';
export const SET_TODAYS_TASKS = 'SET_TODAYS_TASKS';
